import type { DeviceStorage } from '@frontend/deviceStorage';
import type { SubscriptionStatus } from '@phi/subscriptions';
import type { Option } from '@vaaas/fpts/option';
import { days } from '@phi/util';
import { computed, ref } from 'vue';

export type ISubscriptionsState = ReturnType<typeof subscriptions_state_provider>;

export const subscriptions_state_provider = (deviceStorage: DeviceStorage) => {
    const stripe = ref(false);

    const trial_end = computed<Option<number>>({
        get() {
            console.log("P10:")
            console.log(deviceStorage)
            console.log(deviceStorage.user_trial_end)

            return deviceStorage.user_trial_end;
        },

        set(x: Option<number>) {
            deviceStorage.user_trial_end = x;
        },
    });

    const subscription_status =  computed<Option<SubscriptionStatus>>({
        get() {
            return deviceStorage.user_subscription_status;
        },
        set(x) {
            deviceStorage.user_subscription_status = x;
        },
    });

    const trial_days_left = () => {
        if (!trial_end.value)
            return 0;

        console.log("P9:")
        console.log(trial_end.value)

        const trial = new Date(trial_end.value);
        const now = new Date();
        if (now.getTime() >= trial.getTime())
            return 0;
        else
            return Math.round((trial.getTime() - now.getTime()) / days(1));
    };

    const showing_pro_feature_modal = ref(false);
    const showing_view_only_modal = ref(false);

    return {
        subscription_status,
        trial_end,
        trial_days_left,
        stripe,
        showing_pro_feature_modal,
        showing_view_only_modal,
    };
};
